import { Service } from "../shared/Service";

export class GrupoService extends Service{

  constructor(){
    super('grupo');
  }

}